var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectsDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 18.3333V3.66666C14.6667 3.18043 14.4736 2.71412 14.1297 2.3703C13.7859 2.02648 13.3196 1.83333 12.8334 1.83333H9.16671C8.68048 1.83333 8.21416 2.02648 7.87035 2.3703C7.52653 2.71412 7.33337 3.18043 7.33337 3.66666V18.3333",
    stroke: "#4A4A4A",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 5.5H3.66671C2.65419 5.5 1.83337 6.32081 1.83337 7.33333V16.5C1.83337 17.5125 2.65419 18.3333 3.66671 18.3333H18.3334C19.3459 18.3333 20.1667 17.5125 20.1667 16.5V7.33333C20.1667 6.32081 19.3459 5.5 18.3334 5.5Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsDefaultIcon);
export default __webpack_public_path__ + "static/media/ProjectsDefaultIcon.86ac6af9f1e621b84c1e3c6ba9488bf5.svg";
export { ForwardRef as ReactComponent };